import React, { useState } from 'react';
import Select from 'react-select';
import { Button, ExpandCollapse, Search as UDSSearch, Typography } from '@telus-uds/components-web';
import { ModalFieldLabel, Search as SearchWrapper } from './css';
import { fibreCopperConsolidationField } from './constant';
import { Box } from '../../design/css';

const Filter = ({ setFilters, setOfferPage, setSearchByOfferCode }) => {
  const [searchString, setSearchString] = useState('');
  const [filters, setFiltersField] = useState({
    province: [],
    product: [],
    offerType: [],
    term: [],
    speed: [],
    bundled: []
  });
  // Shared styles for all Selects
  const selectStyles = {
    container: base => ({
      ...base,
      width: '300px',
      minWidth: '300px',
      maxWidth: '300px'
    }),
    menuList: base => ({
      ...base,
      maxHeight: '200px' // scrollable dropdown if too many options
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
  };

  // 2️⃣  Generic handler to update the correct key
  const handleChange = (key, selected) => {
    // `selected` is an array of {value,label}
    const valuesArray = selected ? selected.map(opt => opt.value) : [];
    setFiltersField(prev => ({
      ...prev,
      [key]: valuesArray
    }));
  };

  const applyFilters = () => {
    setFilters(filters);
    setOfferPage(1);
  };

  const resetFilters = () => {
    setFiltersField({
      province: [],
      product: [],
      offerType: [],
      term: [],
      speed: [],
      bundled: []
    });
    setFilters('');
    setOfferPage(1);
  };

  const onSearchClick = () => {
    setSearchByOfferCode(searchString);
  };

  const onClear = () => {
    setSearchByOfferCode('');
    setSearchString('');
  };

  // Look up field options by name (robust against field reordering in constant.js)
  const fieldOptions = name =>
    (fibreCopperConsolidationField.find(f => f.name === name) || {}).options || [];

  return (
    <>
      <ExpandCollapse topDivider={false}>
        {(expandProps) => (
        <ExpandCollapse.Panel {...expandProps} panelId="filters" control={<Typography variant={{ bold: true }}>Filters</Typography>}>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ModalFieldLabel>Filter by Province</ModalFieldLabel>
              <Select
                isMulti
                id="province"
                name="province"
                placeholder="Select the province"
                options={fieldOptions('province')}
                styles={selectStyles}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                value={fieldOptions('province').filter(o =>
                  filters.province.includes(o.value)
                )}
                onChange={selected => handleChange('province', selected)}
              />
            </div>

            {/* T023 [US5]: Product filter */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ModalFieldLabel>Filter by Product</ModalFieldLabel>
              <Select
                isMulti
                id="product"
                name="product"
                placeholder="Select the product"
                options={fieldOptions('product')}
                styles={selectStyles}
                value={fieldOptions('product').filter(o =>
                  filters.product.includes(o.value)
                )}
                onChange={selected => handleChange('product', selected)}
              />
            </div>

            {/* T024 [US5]: Offer Type filter */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ModalFieldLabel>Filter by Offer Type</ModalFieldLabel>
              <Select
                isMulti
                id="offerType"
                name="offerType"
                placeholder="Select the offer type"
                options={[
                  { label: 'Plans', value: 'Plans' },
                  { label: 'Add Ons', value: 'Add Ons' },
                  { label: 'Other Offers', value: 'Other Offers' }
                ]}
                styles={selectStyles}
                value={[
                  { label: 'Plans', value: 'Plans' },
                  { label: 'Add Ons', value: 'Add Ons' },
                  { label: 'Other Offers', value: 'Other Offers' }
                ].filter(o => filters.offerType.includes(o.value))}
                onChange={selected => handleChange('offerType', selected)}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ModalFieldLabel>Filter by Term</ModalFieldLabel>
              <Select
                isMulti
                id="term"
                name="term"
                placeholder="select the term"
                options={fieldOptions('term')}
                styles={selectStyles}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                value={fieldOptions('term').filter(o =>
                  filters.term.includes(o.value)
                )}
                onChange={selected => handleChange('term', selected)}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ModalFieldLabel>Filter by Speed</ModalFieldLabel>
              <Select
                isMulti
                id="speed"
                name="speed"
                placeholder="Select the speed"
                options={fieldOptions('speed')}
                styles={selectStyles}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                value={fieldOptions('speed').filter(o =>
                  filters.speed.includes(o.value)
                )}
                onChange={selected => handleChange('speed', selected)}
              />
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '300px'
              }}
            >
              <ModalFieldLabel>Filter by Bundled</ModalFieldLabel>
              <Select
                isMulti
                id="bundled"
                name="bundled"
                placeholder="Select the bundled"
                options={fieldOptions('bundled')}
                styles={selectStyles}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                value={fieldOptions('bundled').filter(o =>
                  filters.bundled.includes(o.value)
                )}
                onChange={selected => handleChange('bundled', selected)}
              />
            </div>
          </div>
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="row"
            pt={64}
            mdJustifyContent="flex-start"
            mdWidth={100}
            mdPadding="16px 0"
            margin="0 auto"
          >
            <Button onClick={applyFilters} variant={{ priority: 'low' }}>
              Apply
            </Button>
            <Box width="2"> </Box>
            <Button onClick={resetFilters} variant={{ priority: 'low' }}>Reset</Button>
          </Box>
        </ExpandCollapse.Panel>
        )}
      </ExpandCollapse>
      <SearchWrapper>
        <div style={{ marginLeft: 20 }}>
          <UDSSearch
            placeholder="Search by Offer code"
            value={searchString || ''}
            onClear={() => onClear()}
            onChange={setSearchString}
            onSubmit={() => onSearchClick()}
          />
        </div>
      </SearchWrapper>
    </>
  );
};

export default Filter;
